import { logDatadog } from 'services/datadogRum'

export const ITEM_POLICY_COMPARE_LOG_MESSAGE = 'lebt.item_policy.compare'

export type ItemPolicyCompareVertical = 'hotel' | 'flight' | 'car_hire'
export type ItemPolicyCompareSurface = 'budget' | 'offer_credit'

export interface ItemPolicyComparisonContext {
  vertical: ItemPolicyCompareVertical
  surface: ItemPolicyCompareSurface
  businessId?: string
  cacheKey?: string
  employeeIds?: Array<string>
  old: unknown
  new: unknown
  deltas?: Record<string, unknown>
}

const compareLogTimeouts: Record<string, number> = {}

export function logItemPolicyComparison(context: ItemPolicyComparisonContext): void {
  const debounceKey = `${context.vertical}:${context.surface}:${context.cacheKey ?? ''}`
  if (compareLogTimeouts[debounceKey]) {
    window.clearTimeout(compareLogTimeouts[debounceKey])
  }

  compareLogTimeouts[debounceKey] = window.setTimeout(() => {
    logDatadog(ITEM_POLICY_COMPARE_LOG_MESSAGE, context, 'info')
    delete compareLogTimeouts[debounceKey]
  }, 500)
}
